module.exports = __webpack_public_path__ + "img/horizontal_7_1_pp1_3009.193cbe71.png";